module.exports = __webpack_public_path__ + "img/affirm_logo_color.9fcf5fd.svg";